<div #formRow class="form-group d-flex flex-column" [ngClass]="{ 'mb-0': noMarginBottom }">
  @if (label && label.length) {
    <label>
      {{ label | translate }} &nbsp;
      @if (tooltipLabel && tooltipLabel.length > 0) {
        <info-tooltip [label]="tooltipLabel" [icon]="tooltipIcon"></info-tooltip>
      }
    </label>
  }
  @if (!options || (options && !options.length)) {
    <ng-select [multiple]="isMultiple" [id]="elementId" [attr.data-cy]="dataCyAttribute" disabled="true"></ng-select>
  }
  @if (options && options.length && areOptionsLoaded && isTags) {
    <ng-select
      class="ng-select-tags"
      [multiple]="isMultiple"
      [id]="elementId"
      [items]="options"
      [(ngModel)]="selectedValues"
      [bindLabel]="optionKeyText"
      [bindValue]="optionKey"
      [attr.data-track-category]="trackCategory"
      [attr.data-track-action]="trackAction"
      [attr.data-cy]="dataCyAttribute"
      (change)="onChange()"
      (add)="onAdd()"
      (remove)="onRemove()"
      [trackByFn]="trackById"
      [compareWith]="compareWith"
      [closeOnSelect]="false"
      [disabled]="inputDisabled"
    >
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <div [style.background-color]="item.color ? item.color : '#0058FF'" class="ng-value-label-tags">
          <span
            [style]="{
              color: getTagColor(item),
              borderColor: isTagWhite(item) ? '#000' : '#fff'
            }"
            >{{ item.name }}</span
          >
          @if (!inputDisabled) {
            <span
              class="ng-value-icon right"
              [style.background-color]="item.color ? item.color : '#0058FF'"
              (click)="clear(item)"
              data-cy="tags-clear-btn"
              aria-hidden="true"
              >×</span
            >
          }
        </div>
      </ng-template>
    </ng-select>
  }
  @if (options && options.length && areOptionsLoaded && !isTags) {
    <ng-select
      [multiple]="isMultiple"
      [id]="elementId"
      [items]="options"
      [(ngModel)]="selectedValues"
      [bindLabel]="optionKeyText"
      [bindValue]="optionKey"
      [attr.data-track-category]="trackCategory"
      [attr.data-track-action]="trackAction"
      [attr.data-cy]="dataCyAttribute"
      (change)="onChange()"
      (add)="onAdd()"
      (remove)="onRemove()"
      [trackByFn]="trackById"
      [compareWith]="compareWith"
      [closeOnSelect]="false"
      [disabled]="inputDisabled"
    >
    </ng-select>
  }
</div>
